import { sessionStorageUtil } from '@/core/services/storage/utils/sessionStorageUtil';

export const SEARCH_TRIGGERED_SESSION_KEY = 'searchTriggered';

export function markSearchTriggered(): void {
  sessionStorageUtil.setItem(SEARCH_TRIGGERED_SESSION_KEY, true);
}

export function consumeSearchTriggered(): boolean {
  const triggered = sessionStorageUtil.getItem<boolean>(SEARCH_TRIGGERED_SESSION_KEY);
  if (triggered !== true) {
    return false;
  }
  sessionStorageUtil.removeItem(SEARCH_TRIGGERED_SESSION_KEY);
  return true;
}
